<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'OverdueInvoicesConfirmDialog',
  mixins: [baseMixin],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    selectedClientCount: {
      type: Number,
      required: true,
    },
    totalUnchargedInterestValueExTax: {
      type: Number,
      required: true,
    },
    isGeneratingInvoices: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      invoiceCenterLocale: 'finance/currentInvoiceCenterLocale',
    }),
    messageHtml() {
      const count = this.$n(
        this.selectedClientCount,
        null,
        this.invoiceCenterLocale
      )

      return this.$tc(
        'finance.overdueInvoices.generateInterestChargesDialogMessageHtml',
        count,
        { count }
      )
    },
    generateBtnText() {
      return this.isGeneratingInvoices
        ? this.$t(
            'finance.overdueInvoices.generateInterestChargesDialogConfirmBtnLoadingText'
          )
        : this.$t(
            'finance.overdueInvoices.generateInterestChargesDialogConfirmBtnText'
          )
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<template>
  <v-dialog
    :value="showDialog"
    max-width="850px"
    persistent
    @input="(v) => v || closeDialog()"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5 mb-1">{{
          $t('finance.overdueInvoices.generateInterestChargesDialogTitle')
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="7">
            <div class="mb-4">
              <span v-sanitized-html="messageHtml" data-testid="message"></span>
            </div>
            <v-alert dense type="info" text>
              {{
                $t('finance.overdueInvoices.generateInterestChargesDialogAlert')
              }}
            </v-alert></v-col
          >
          <v-col>
            <v-card flat>
              <v-card-title>{{
                $t('finance.overdueInvoices.summaryCardTitle')
              }}</v-card-title>
              <v-simple-table dense>
                <template v-slot>
                  <tbody>
                    <tr>
                      <td>{{
                        $t('finance.overdueInvoices.columnHeadings.clientCount')
                      }}</td>
                      <td class="text-right">
                        <i18n-n
                          data-testid="selected-client-count"
                          :value="selectedClientCount"
                          :locale="invoiceCenterLocale"
                        ></i18n-n
                      ></td>
                    </tr>
                    <tr>
                      <td>{{
                        $t(
                          'finance.overdueInvoices.columnHeadings.totalInterest'
                        )
                      }}</td>
                      <td class="text-right font-weight-bold">
                        <i18n-n
                          data-testid="total-uncharged-interest"
                          :value="totalUnchargedInterestValueExTax"
                          format="currency"
                          :locale="invoiceCenterLocale"
                        ></i18n-n
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          :disabled="isGeneratingInvoices"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          data-testid="generate-btn"
          color="primary"
          :disabled="isGeneratingInvoices"
          @click="confirm"
        >
          {{ generateBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
